import axiosIntents from '@/utils/axios-intents'

import i18n from '@/i18n'

const state = {
    Stripe: null,
    stripe_initialized: null,
}

const getters = {
    client_secret: state => state.client_secret,
}

const mutations = {
    saveStripe(state, Stripe) {
        state.Stripe = Stripe
        state.stripe_initialized = null
    },
    stripeInitialized(state, promise) {
        state.stripe_initialized = promise
    },
}

const actions = {
    stripeInit({state, commit}, config) {
        if (state.stripe_initialized) {
            return state.stripe_initialized
        } else {
            if (state.Stripe) {
                return Promise.resolve(state.Stripe)
            } if ('Stripe' in window) {
                const Stripe = window.Stripe(
					process.env.VUE_APP_STRIPE_API_KEY, 
					{ locale: 'en' }
				);

                commit('saveStripe', Stripe)
                return Promise.resolve(state.Stripe)
            } else {
                let stripe_initialized = new Promise((resolve, reject) => {
                    let script = document.createElement('script')
                        script.src = 'https://js.stripe.com/v3/'

                        script.onreadystatechange = script.onload = () => {
                            if (!script.readyState || /loaded|complete/.test(script.readyState)) {
                                const Stripe = window.Stripe(
									process.env.VUE_APP_STRIPE_API_KEY, 
									{ locale: 'en' }
								);

                                commit('saveStripe', Stripe)
                                resolve(state.Stripe)
                            }
                        }

                        script.onerror = () => {
                            reject(new Error(i18n.t('error_by_stripe_loading')))
                        }

                    document.getElementsByTagName('head')[0].appendChild(script)
                })

                commit('stripeInitialized', stripe_initialized)

                return stripe_initialized
            }
        }
    },

    stripePaymentConfirmation({dispatch}, { card_token, client_secret }) {
        return dispatch('stripeInit').then(stripe => {
            return stripe.confirmCardPayment(client_secret, card_token ? {
                payment_method: card_token
            } : {}).then(confirmation_result => {
                if (confirmation_result?.error) {
                    return Promise.reject(confirmation_result?.error)
                }

                return Promise.resolve(confirmation_result)
            })
        }).catch(error => {
            console.log('stripePaymentConfirmation error', error)
            return Promise.reject(error)
        })
    },
    stripePaymentConfirmationIFP({dispatch}, {card_token, client_secret, return_url }) {
        return dispatch('stripeInit').then(stripe => {
            // Create options object based on available parameters
            const options = card_token ? { payment_method: card_token } : {};

            // Only add return_url if it's provided
            if (return_url) {
                options.return_url = return_url;
            }

            return stripe.confirmAfterpayClearpayPayment(client_secret, Object.keys(options).length > 0 ? options : {})
                .then(confirmation_result => {
                    if (confirmation_result?.error) {
                        return Promise.reject(confirmation_result?.error)
                    }

                    return Promise.resolve(confirmation_result)
                })
        }).catch(error => {
            console.log('stripePaymentConfirmationIFP error', error)

            return Promise.reject(error)
        })
    },
    stripePaymentConfirmationAfterpayClearpay({dispatch}, {client_secret, return_url, checkout_url}) {
        return dispatch('stripeInit').then(stripe => {
                        
            return stripe.confirmAfterpayClearpayPayment(
                client_secret, 
                {
                    payment_method: {
                        type: 'afterpay_clearpay',
                        billing_details: {
                            // These might be required for Afterpay
                            name: 'Customer Name',
                            email: 'customer@example.com'
                        }
                    },
                    return_url: return_url
                }
            ).then(result => {               
                if (result.error) {
                    console.error('Afterpay payment error in result:', result.error);
                    return Promise.reject(result.error);
                }
                
                return Promise.resolve(result);
            });
        }).catch(error => {
            console.error('Afterpay payment error in catch:', error);
            
            // Log the specific error details to help diagnose
            if (error.type) console.log('Error type:', error.type);
            if (error.code) console.log('Error code:', error.code);
            if (error.message) console.log('Error message:', error.message);       
            
            // Only redirect for certain errors
            if (checkout_url && (
                error.message?.includes('error_by_stripe_loading') || 
                error.code === 'resource_missing'
            )) {
                console.log('Redirecting to checkout with failed status');
                window.location.href = `${checkout_url}?redirect_status=failed`;
            }
            return Promise.reject(error);
        });
    },

    stripePaymentConfirmationKlarna({dispatch}, {card_token, client_secret, return_url, checkout_url}) {
          const options = card_token ? { payment_method: card_token } : {};
           if (return_url) {
                options.return_url = return_url;
            }
        return dispatch('stripeInit').then(stripe => {
                        
            return stripe.confirmKlarnaPayment(
                client_secret, 
                Object.keys(options).length > 0 ? options : {},
                
            ).then(result => {   
                console.log(result)            
                if (result.error) {
                    console.error('payment error in result:', result.error);
                    return Promise.reject(result.error);
                }
                
                return Promise.resolve(result);
            });
        }).catch(error => {
            console.error('payment error in catch:', error);
            
            return Promise.reject(error);
        });
    },

}

export default {
	state,
	getters,
	mutations,
	actions,
}
